import React, { useContext } from 'react';
import _get from 'lodash/get';

import { Notes } from 'components';
import { OrderServiceContext } from 'components/OrderServiceDetails';

export default function RequestNotes() {
  const { orderService, isDisabled } = useContext(OrderServiceContext);

  const id = _get(orderService, 'id', '');
  const orderStatus = _get(orderService, 'status', '');
  const isCreatable = true;
  const isDeletable = orderStatus !== 'PROCESSED';

  return (
    <Notes.Provider
      type="REQUEST"
      id={id}
      isDisabled={isDisabled}
      isCreatable={isCreatable}
      isDeletable={isDeletable}
    >
      <Notes.Container>
        <Notes.Form />
        <Notes.List />
      </Notes.Container>
    </Notes.Provider>
  );
}
